import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.RISKS}` as const;

export const EXECUTIVE_SUMMARY_RISKS_NAMES = {
  MAIN_RISKS: 'mainRisks',
  MEASURES: 'measures',
} as const;

export interface IRisksExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS]: string;
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES]: string;
}

export const risksExecutiveSummaryInitialValues: IRisksExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS]: '',
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES]: '',
};
